import type { UserPhraseSummary } from '@/api/vocabulary'
import type { UserWordSummary } from '@/types/user'
import type { PracticeUnitRef } from '@/types/practiceUnit'

/** Map catalog/user phrases into the shared picker row shape (one unit = one row). */
export function phraseAsPickerWord(p: UserPhraseSummary): UserWordSummary {
  return {
    id: p.id,
    wordId: p.phraseId,
    word: p.surface,
    translation: p.translation,
    status: p.status,
    nextReviewAt: p.nextReviewAt,
    reviewCount: p.reviewCount,
    source: p.source,
    knownSenseCount: 1,
    knownTranslations: [p.translation],
    dateAdded: p.dateAdded,
    unitKind: 'PHRASE',
    phraseUnitType: p.unitType,
  }
}

export function toPracticeUnitRef(row: UserWordSummary): PracticeUnitRef {
  return {
    kind: row.unitKind === 'PHRASE' ? 'PHRASE' : 'WORD',
    id: row.id,
  }
}

export function mergeWordAndPhraseRows(
  words: UserWordSummary[],
  phrases: UserPhraseSummary[],
): UserWordSummary[] {
  return [...words, ...phrases.map(phraseAsPickerWord)]
}
